import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import throttle from 'lodash/throttle';
import { searchIcons } from '../../utils/fontawesomeSearch.js';
export default {
  name: 'CoreIcons',
  props: {
    value: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    faStyle: {
      type: String,
      default: 'regular'
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      icons: [],
      icon: null,
      search: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    // initial () {
    //   return this.value;
    // },
    fontStyle: function fontStyle() {
      if (this.faStyle === 'regular') {
        return 'far';
      } else if (this.faStyle === 'light') {
        return 'fal';
      } else {
        return 'fas';
      }
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return this.required ? [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }] : [];
    }
  }),
  watch: {
    value: function value() {
      this.icon = this.value;
    },
    search: throttle(function (search) {
      this.icons = searchIcons(search);
    }, 250)
  },
  mounted: function mounted() {
    this.icon = this.value;
  },
  methods: {
    faIcon: function faIcon(iconName) {
      iconName = iconName || '';

      if (iconName.trim() === '') {
        return 'fal fa-image';
      }

      return "".concat(this.fontStyle, " ").concat(iconName.startsWith('fa-') ? iconName : "fa-".concat(iconName));
    }
  }
};